import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import { ROUTE_GROUP, HomePage } from "../../../routes/constants/route-info";
import qs from "qs";
import useSpecial from "../../../../hooks/useSpecial";
import useUser from "../../../../hooks/useUsers";
import { autoOasis, speedMate } from "../../../../routes";
import {
  autoOasisCodeString,
  speedMateCodeString,
} from "../../../../routes/constants/path";
import { BoxWrap, MainBox, StyledIcon, StyledTitle } from "../../Layout/Menus";
import Box from "./components/Box";

interface Props {}
const Menus: React.FC<Props> = () => {
  const { pathname, search } = useLocation();
  const { getAdminInfo } = useUser();
  const info = getAdminInfo();

  const { special, setSpecial } = useSpecial();
  const [selectIdx, setIdx] = useState(0);

  useEffect(() => {
    if (!special || special.includes("undefiend")) {
      const type = pathname.includes("speed-mate")
        ? speedMateCodeString
        : pathname.includes("autooasis")
        ? autoOasisCodeString
        : undefined;
      if (type) {
        const value = qs.parse(search)[`?${type}`] || `${info?.repairShopCode}`;
        setSpecial(`?${type}=${value}`);
      }
    }
  }, [pathname, special]);

  const array = useMemo(
    () =>
      special === speedMateCodeString || pathname.includes("speed-mate")
        ? speedMate
        : autoOasis,
    [special]
  );

  const setInitialIndex = useCallback(() => {
    for (let i = 0; i < array.length; i += 1) {
      if (array[i].mainLink.path === pathname) return i;
      for (let j = 0; j < array[i].subLink.length; j += 1) {
        if (pathname.includes(array[i].subLink[j].path)) return i;
      }
    }

    return -1;
  }, [array, pathname]);

  useEffect(() => {
    setIdx(setInitialIndex());
  }, [pathname]);

  return (
    <>
      <BoxWrap>
        {array.map(({ mainLink, subLink }, index) => {
          if (mainLink.path) {
            return (
              <Link
                to={`${mainLink.path}${special ? `${special}` : ""}`}
                key={index}
              >
                <MainBox
                  onClick={() => setIdx(index)}
                  isNow={pathname === mainLink.path}
                >
                  <StyledTitle>
                    <StyledIcon> {mainLink.icon}</StyledIcon>
                    {mainLink.name}
                  </StyledTitle>
                </MainBox>
              </Link>
            );
          }
          return (
            <Box
              setIdx={() => {
                setIdx(index);
              }}
              setClose={() => {
                setIdx(-1);
              }}
              open={selectIdx === index}
              key={index}
              subLink={subLink}
              mainLink={mainLink}
            />
          );
        })}
      </BoxWrap>
    </>
  );
};

export default Menus;
